var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "image-modal image-modal--roomtype",
      attrs: { "close-on-click": true, "is-open": true },
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("image-rotator", {
        attrs: {
          images: _vm.images,
          "pagination-enabled": true,
          thumbnail: false,
          enableKeys: true
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76f56df4", { render: render, staticRenderFns: staticRenderFns })
  }
}